module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h1', {
    staticClass: "title"
  }, [_vm._v("MARTIN GILBERT "), _c('br'), _vm._v("IN ISHMAEL’S HOUSE")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("A HISTORY OF JEWS IN MUSLIM LANDS")]), _vm._v(" "), _c('p', {
    staticClass: "logo"
  }, [_vm._v("YALE UNIVERSITY PRESS"), _c('br'), _vm._v("NEW HAVEN AND LONDON")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7162c333","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/title.vue
// module id = 63
// module chunks = 0